import { useTranslation } from 'react-i18next'

import { ModalWrapper } from 'src/components'
import { ModalInner } from './modal.component'
import { useStyles } from './styles'

interface IProps {
  open: boolean
  onClose: () => void
}

export const MediaAddForm = ({ open, onClose }: IProps) => {
  const [t] = useTranslation()
  const classes = useStyles()

  return (
    <ModalWrapper
      open={open}
      onClose={onClose}
      title={t('create-media-button-text.v')}
      className={classes.modalWrapper}
    >
      <ModalInner handleClose={onClose} />
    </ModalWrapper>
  )
}
